package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.Universe
import fr.manyverse.app.domain.model.UniverseConfig
import fr.manyverse.app.domain.repository.UniverseRepository
import fr.manyverse.app.domain.validation.UniverseValidator

class CreateUniverseUseCase(
    private val universeRepository: UniverseRepository
) {
    suspend operator fun invoke(
        name: String,
        config: UniverseConfig,
        createdBy: String
    ): Result<Universe> {
        UniverseValidator.validateForCreation(name, config).onFailure {
            return Result.failure(it)
        }
        val finalName = name.trim()
        val finalConfig = config.copy(
            version = UniverseConfig.CURRENT_VERSION,
            displayName = finalName
        )
        return universeRepository.createUniverse(finalName, finalConfig, createdBy)
    }
}
